import React from "react";
import { QueryRenderer, graphql } from "react-relay";
import { RefreshIndicator } from "material-ui";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import environment from "../../relay/environment";
import TripDetails from "./TripDetails";

@connect(state => ({
  windowHeight: state.Responsive.get("windowHeight"),
  filter: state.Trips.get("filter"),
  selectedUser: state.Trips.get("selectedUser")
}))
class Renderer extends React.Component {
  static propTypes = {
    windowHeight: PropTypes.number.isRequired,
    activeTrip: PropTypes.string.isRequired
  };

  render() {
    const { windowHeight, activeTrip } = this.props;
    const top = (windowHeight - 161) / 2 + 161;

    const loadingEl = (
      <RefreshIndicator top={top} left={900} status="loading" />
    );

    return (
      <QueryRenderer
        environment={environment}
        variables={{
          tripId: activeTrip
        }}
        query={graphql`
          query TripDetailsRenderer_TripDetails_Query($tripId: ID!) {
            allUsers {
              edges {
                node {
                  id
                  username
                  firstName
                  lastName
                  groups
                }
              }
            }
            trip(id: $tripId) {
              id
              searchId
              tripName
              primaryTravelerName
              destination
              dateString
              numAdults
              numChildren
              specificDates
              startDate
              endDate
              timeFrame
              category {
                id
                name
              }
              owner {
                id
                username
                firstName
                lastName
              }
              travelers {
                id
                firstName
                lastName
                isPrimaryTraveler
                primaryTravelerName
                primaryTraveler {
                  id
                }
                birthdate
                adult
                currentTier
                fired
                lowPriority
                needsTraining
                needsVetting
                highPriority
              }
              segments {
                id
                vendor {
                  id
                  name
                  amenityPrograms
                }
                trip {
                  id
                  searchId
                }
                name
                dateString
                startDate
                endDate
                category
                bedType
                amenityProgram
                numAdults
                numChildren
                smokingRoom
                rates
                currency
                averageDailyRate
                cancellationDeadline
                dropbox
                invoiced
                vipDrafted
                booked
                cancelled
                sabreLocator
                confirmationNumber
                cancellationNumber
                vipLetter
                notes {
                  id
                  owner {
                    id
                    firstName
                  }
                  content
                  created
                }
              }
              history {
                user {
                  firstName
                  lastName
                }
                comment
                dateCreated
              }
              notes {
                owner {
                  id
                  firstName
                }
                content
                created
              }
              vipNotes
              inquiry
              active
              cancelled
              inbox
              created
              modified
              tier
              fired
              lowPriority
              highPriority
              needsTraining
              needsVetting
              insideCircle
              prospect
              tasks {
                id
                taskType
                description
                completed
                dueDate
                voided
                voidDate
                history {
                  name
                  action
                  timestamp
                }
              }
            }
          }
        `}
        render={({ error, props }) => {
          if (error) {
            return <div>{error.message}</div>;
          } else if (props) {
            const {
              trip,
              allUsers: { edges: userEdges }
            } = props;
            const users = userEdges.map(({ node }) => node);

            return <TripDetails trip={trip} users={users} />;
          }

          return loadingEl;
        }}
      />
    );
  }
}

export default Renderer;



// WEBPACK FOOTER //
// /src/components/Trips/TripDetailsRenderer.js